import * as React from "react";
import { UitkCardAloha, UitkCardAlohaLink, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkBadge, UitkBadgeTheme, UitkBadgeSize } from "uitk-react-badge";
import { useLocalization } from "@shared-ui/localization-context";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { PackageCardProps } from "./typings";
import PricesAndDate from "./components/PricesAndDate";
import { CardTitle } from "./components/CardTitle";
import { HotelRating } from "./components/HotelRating";
import { AddressAndNeighborhood } from "./components/AddressAndNeighborhood";
import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";
import LoBDetails from "./components/LobDetails";
import LoBBadge from "./components/LobBadge";
import DescriptionAndGuestReviewSectionWrapper from "./components/DescriptionAndGuestReviewSectionWrapper";
import { UitkImage } from "uitk-react-experimental-images";
import { UitkLayoutPosition } from "uitk-react-layout-position";

export const PackageCardImageLeft = ({ packageItem, index, language, isMobile }: PackageCardProps) => {
  const packageType = "fh";
  const { formatText } = useLocalization();

  return (
    <UitkCardAloha className="all-t-margin-three" padded={true}>
      <UitkLayoutGrid columns={2}>
        <UitkLayoutGridItem colSpan={1} className="all-r-margin-two">
          <div>
            <UitkFigure
              ratio={UitkFigureAspectRatioType.R16_9}
              className="all-image-fit-cover uitk-card-aloha-roundcorner-all"
            >
              <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
              <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
                <UitkBadge
                  theme={UitkBadgeTheme.FAMILY_FRIENDLY}
                  size={UitkBadgeSize.SMALL}
                  className="all-y-padding-one all-x-padding-one"
                >
                  <LoBBadge packageType={packageType} />
                </UitkBadge>
              </UitkLayoutPosition>
            </UitkFigure>
          </div>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={1}>
          <UitkCardAlohaContentSection padded={false} className="all-x-padding-three">
            <UitkLayoutFlex justifyContent="space-between" className="truncate">
              <UitkLayoutFlexItem className="truncate">
                <div>
                  <HotelRating rating={packageItem.hotelStarRating} isText={true} />
                  <CardTitle cardTitle={packageItem.hotelName} />
                  <AddressAndNeighborhood packageItem={packageItem} />
                  {packageItem.showHotelGuestRating && (
                    <ReviewCountAndRating
                      hotelOverallReviewRating={Number(packageItem.hotelReviewScore)}
                      reviewCount={Number(packageItem.hotelReviewTotal)}
                      language={language}
                    />
                  )}
                  <LoBDetails packageItem={packageItem} />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <div>
                  <PricesAndDate packageItem={packageItem} renderSavingBadge={true} renderDates={false} />
                </div>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
            <DescriptionAndGuestReviewSectionWrapper packageItem={packageItem} language={language} marginOnTop={true} />
            <UitkCardAlohaLink>
              <TrackedLink
                className="uitk-card-link"
                rfrr={`card-${index}`}
                href={packageItem.shopUrl}
                aria-label={formatText("package.card.ariaLabel.fh")}
                moduleName="packages"
              />
            </UitkCardAlohaLink>
          </UitkCardAlohaContentSection>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkCardAloha>
  );
};
